var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgColumnsThree = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M14.688 2.813H3.313a.5.5 0 0 0-.5.5v11.375a.5.5 0 0 0 .5.5h11.375a.5.5 0 0 0 .5-.5V3.313a.5.5 0 0 0-.5-.5Zm-7.75 0v12.375M11.063 3v12.375" }) }))); };
export default SvgColumnsThree;
